import "./style.scss";
import { FC } from "react";

interface ICustomSwitchProps {
  label: string;
  value: boolean | undefined;
  onChange: (checked: boolean) => void;
}

const CustomSwitch: FC<ICustomSwitchProps> = ({ label, value, onChange }) => {
  return (
    <label className="custom-switch">
      <p>{label}</p>
      <div className={`switch ${value ? "on" : "off"}`} onClick={() => onChange(!value)}>
        <div className={`thumb ${value ? "on" : "off"}`} />
      </div>
    </label>
  );
};

export default CustomSwitch;
